<template src="./html/Customers.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'data', 'item'],
		components: {

		},
		data () {
			return {
				toggle: false,
				closed_task: {
					closing_id: null,
					task_id: null,
					schedule_id: null,
					user: null,
					customer: null,
					customer_id: null,

					start: null,
					end: null,

					total_time: null,
					closing_time: null,
					total_time_spent: null,
					rest_time: null,
					rest_subject: null,
					comment: null,
				},

				schedule: null,

				closing_time: {
					hours: null,
					minutes: null,
				},

				rest_time: {
					hours: null,
					minutes: null,
				},

				start: null,
				end: null,
			}
		},
		watch: {
			'closed_task.closing_time'() {
				if(this.closed_task.closing_time) {
					var closing_time = this.closed_task.closing_time
				} else {
					var closing_time = 0
				}

				var duration = moment.duration().add(closing_time, 'seconds')

				var hours = parseInt(duration.asHours())
				var minutes = parseInt(duration.minutes())

				this.closing_time.hours = hours
				this.closing_time.minutes = minutes
			},
			'closed_task.rest_time'() {
				if(this.closed_task.rest_time) {
					var rest_time = this.closed_task.rest_time
				} else {
					var rest_time = 0
				}

				var duration = moment.duration().add(rest_time, 'seconds')

				var hours = parseInt(duration.asHours())
				var minutes = parseInt(duration.minutes())

				this.rest_time.hours = hours
				this.rest_time.minutes = minutes
			},
			//-- closing_time
				'closing_time.hours': function () {
					if(this.closing_time.hours) {
						this.closing_time.hours = parseInt(this.closing_time.hours)
					} else {
						this.closing_time.hours = null
					}
					this.setClosingTime()
					this.calculateTotalTimeSpent()
					//this.calculateRestTime()
				},
				'closing_time.minutes': function () {
					if(this.closing_time.minutes) {
						this.closing_time.minutes = parseInt(this.closing_time.minutes)
						if(this.closing_time.minutes > 59) {
							this.closing_time.minutes = 59
						}
					} else {
						this.closing_time.minutes = null
					}
					this.setClosingTime()
					this.calculateTotalTimeSpent()
					//this.calculateRestTime()
				},
			//-- rest_time
				'rest_time.hours': function () {
					if(this.rest_time.hours) {
						this.rest_time.hours = parseInt(this.rest_time.hours)
					} else {
						this.rest_time.hours = null
					}
					this.setRestTime()
					this.calculateTotalTimeSpent()
				},
				'rest_time.minutes': function () {
					if(this.rest_time.minutes) {
						this.rest_time.minutes = parseInt(this.rest_time.minutes)
						if(this.rest_time.minutes > 59) {
							this.rest_time.minutes = 59
						}
					} else {
						this.rest_time.minutes = null
					}
					this.setRestTime()
					this.calculateTotalTimeSpent()
				},
			schedule() {
				if(!this.closed_task.closing_id) {
					if(this.schedule) {
						this.closed_task.schedule_id = this.schedule.id
					} else {
						this.closed_task.schedule_id = null
					}
				}
			}
		},
		mounted() {
			this.closed_task.task_id = this.item.id
		},
		created () {
		},
		methods: {
			setClosingTime() {
				if(this.closing_time.hours) {
					var hours = this.closing_time.hours
				} else {
					var hours = 0
				}

				if(this.closing_time.minutes) {
					var minutes = this.closing_time.minutes
				} else {
					var minutes = 0
				}

				var duration = moment.duration().add(hours, 'hours').add(minutes, 'minutes')

				var seconds = duration.asSeconds()

				this.closed_task.closing_time = seconds
			},

			setRestTime() {
				if(this.rest_time.hours) {
					var hours = this.rest_time.hours
				} else {
					var hours = 0
				}

				if(this.rest_time.minutes) {
					var minutes = this.rest_time.minutes
				} else {
					var minutes = 0
				}

				var duration = moment.duration().add(hours, 'hours').add(minutes, 'minutes')

				var seconds = duration.asSeconds()

				this.closed_task.rest_time = seconds
			},

			dateChange() {
				if(!this.closed_task.closing_id) {
					var start = moment(this.closed_task.start)
					var end = moment(this.closed_task.end)

					if(end.isValid() && start.isValid()) {
						var diff = end.diff(start)

						var seconds = moment.duration(diff).asSeconds()

						this.closed_task.total_time = seconds
						this.closed_task.closing_time = seconds
						this.closed_task.total_time_spent = seconds
					}
				}
			},

			calculateTotalTime(update) {
				var start = moment(this.closed_task.start)
				var end = moment(this.closed_task.end)

				if(end.isValid() && start.isValid()) {
					var diff = end.diff(start)

					var seconds = moment.duration(diff).asSeconds()

					this.closed_task.total_time = seconds
				}
			},

			calculateTotalTimeSpent() {
				var closing_time = this.closed_task.closing_time
				var rest_time = this.closed_task.rest_time

				var seconds = closing_time - rest_time
				this.closed_task.total_time_spent = seconds
			},

			closedTaskCustomer(customer, tasks_closing = null) {
				this.clearData()
				if(customer) {
					this.closed_task.customer = customer
					this.closed_task.customer_id = customer.id
					if(!this.toggle) {
						this.toggle = true
					} else {
						this.toggle = true
					}
				}

				if(tasks_closing) {
					var closing = tasks_closing

					var start = moment(closing.start).toISOString()
					var end = moment(closing.end).toISOString()

					this.start = start
					this.end = end

					this.closed_task.start = start
					this.closed_task.end = end

					this.closed_task.schedule_id = closing.schedule_id
					this.closed_task.total_time = closing.total_time
					this.closed_task.closing_time = closing.closing_time
					this.closed_task.rest_time = closing.rest_time
					this.closed_task.total_time_spent = closing.total_time_spent

					this.closed_task.comment = closing.comment
					this.closed_task.closing_id = closing.id
					this.closed_task.rest_subject = closing.rest_subject
				}/* else if(schedules) {
					var closing = this.item.schedules[0]

					var start = moment(closing.estimated_start)
					var end = moment(closing.estimated_end)

					this.closed_task.start = start.toISOString()
					this.closed_task.end = end.toISOString()
				}*/
				this.closed_task.user = null
			},

			close() {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.closure_be_made"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.formatData()
							if(that.closed_task.user) {
								var api = 'admin/projects/tasks/closing/users'
							} else if(that.closed_task.customer) {
								var api = 'admin/projects/tasks/closing/cutomers'
							}
							that.$http.post(api, that.closed_task)
							.then(response => {
								that.toggle = false
								that.$emit('reload')
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type,
								})
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},

			updateClosing() {
				var data = this.closed_task
				if(data.start) {
					var start = moment(data.start)
					data.start = start.format('YYYY-MM-DD H:mm:ss')
				}
				if(data.end) {
					var end = moment(data.end)
					data.end = end.format('YYYY-MM-DD H:mm:ss')
				}

				if(this.closed_task.user) {
					var l = Ladda.create(document.querySelector("#btn-update-closing"))
					var api = 'admin/projects/tasks/closing/users/'+this.closed_task.closing_id
				} else if(this.closed_task.customer) {
					var l = Ladda.create(document.querySelector("#btn-update-closing-customer"))
					var api = 'admin/projects/tasks/closing/cutomers/'+this.closed_task.closing_id
				}
				l.start()
				this.$http.put(api, data)
				.then(response => {
					l.stop()
					this.$emit('reload')
					this.toggle = false
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type
					})
				}).catch(function(response) {
					l.stop()
					console.log(response)
				})
			},

			clearData() {
				this.toggle = false
				this.closed_task.closing_id = null
				this.closed_task.schedule_id = null
				this.closed_task.user = null
				this.closed_task.customer = null
				this.closed_task.start = null
				this.closed_task.end = null
				this.closed_task.closing_time = null
				this.closed_task.total_time_spent = null
				this.closed_task.rest_subject = null
				this.closed_task.rest_time = null
				this.closed_task.comment = null

				this.schedule = null
			},

			formatData() {
				if(this.closed_task.start) {
					var start = moment(this.closed_task.start)
					this.closed_task.start = start.format('YYYY-MM-DD H:mm:ss')
				}
				if(this.closed_task.end) {
					var end = moment(this.closed_task.end)
					this.closed_task.end = end.format('YYYY-MM-DD H:mm:ss')
				}
			},
			scheduleSelected() {
				if(this.schedule) {
					var closing = this.schedule

					var start = moment(closing.estimated_start)
					var end = moment(closing.estimated_end)

					this.closed_task.start = start.toISOString()
					this.closed_task.end = end.toISOString()

					this.dateChange()
				}
			},
			filterSchedule() {
				var schedules = Object.assign([], this.item.schedules)
				if(this.closed_task.customer) {
					if(this.closed_task.customer.tasks_closing) {
						if(this.closed_task.customer.tasks_closing.length) {
							this.closed_task.customer.tasks_closing.map(function(e) {
								for (var i = 0; i < schedules.length; i++) {
									var element = schedules[i]
									if(element.id == e.schedule_id) {
										schedules.splice(i, 1)
									}
								}
							})
						}
					}
				}
				return schedules
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/tasks/views/Customers.vue